import { render, staticRenderFns } from "./MaintenanceItemPrototypeEquipment.vue?vue&type=template&id=65dfeb01&scoped=true"
import script from "./MaintenanceItemPrototypeEquipment.vue?vue&type=script&lang=ts"
export * from "./MaintenanceItemPrototypeEquipment.vue?vue&type=script&lang=ts"
import style0 from "./MaintenanceItemPrototypeEquipment.vue?vue&type=style&index=0&id=65dfeb01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfeb01",
  null
  
)

export default component.exports